import { render, staticRenderFns } from "./bookingManifestGoodsInfo.vue?vue&type=template&id=4f32e5d2&scoped=true&"
import script from "./bookingManifestGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./bookingManifestGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./bookingManifestGoodsInfo.vue?vue&type=style&index=0&id=4f32e5d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f32e5d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f32e5d2')) {
      api.createRecord('4f32e5d2', component.options)
    } else {
      api.reload('4f32e5d2', component.options)
    }
    module.hot.accept("./bookingManifestGoodsInfo.vue?vue&type=template&id=4f32e5d2&scoped=true&", function () {
      api.rerender('4f32e5d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/bookingManifestGoodsInfo.vue"
export default component.exports